<template>
  <fo-layout>
    <div class="filter-input" ref="filter">
      <industry v-model="cond.article_industry_id" @change="readList"></industry>
      <areas v-model="cond.article_business_id" @change="readList"></areas>
      <a-input-search class="item-input card-shadow" placeholder="Input keyword"
        allowClear
        v-model="cond.keyword"
        @search="searchHandle" />
    </div>
    <a-spin :spinning="loading">
      <a-row :gutter="30" v-if="data.length">
        <a-col :sm="12" v-for="(item, ind) in data" :key="ind">
          <div class="pb-30">
            <card
              :imgurl="item.article_poster_url"
              :title="item.article_title"
              :industries="item.article_industry_title_zh"
              :areas="item.article_business_title_zh"
              :author="item.article_author"
              :date="item.article_atime"
              @click="$router.push('./publication/' + item.code)">
            </card>
          </div>
        </a-col>
      </a-row>
      <a-row :gutter="30" v-else>
        <a-col :sm="12" v-for="(item, ind) in 3" :key="ind">
          <div class="pb-30">
            <card></card>
          </div>
        </a-col>
      </a-row>
    </a-spin>
    <div class="pagination-style pt-30" v-if="data.length">
      <a-pagination
        :default-current="1"
        :total="total"
        :page-size="cond.page_size"
        @change="onChange" />
    </div>
  </fo-layout>
</template>

<script>
import card from './comps/cardPublication.vue'
import industry from './comps/selectedIndustry.vue'
import areas from './comps/selectedAreas.vue'
export default {
  components: {
    card,
    areas,
    industry
  },
  data () {
    return {
      loading: false,
      total: 0,
      data: [],
      cond: {
        page_num: 1,
        page_size: 6,
        keyword: ''
      }
    }
  },
  watch: {
    '$route' (obj) {
      if (obj.params.param) {
        window.scroll(0, 0)
      }
    }
  },
  mounted () {
    this.readList()
  },
  methods: {
    onChange (current, pageSize) {
      window.scroll(0, (this.$refs.filter.offsetTop - 130))
      this.cond.page_num = current
      this.readList()
    },
    searchHandle () {
      this.cond.page_num = 1
      this.readList()
    },
    readList () {
      this.loading = true
      this.get({
        url: 'articleRead',
        data: this.cond
      }, (res) => {
        this.loading = false
        if (res.code) {
          this.data = res.data.items
          this.total = res.data.total
        } else {
          this.data = []
          this.total = 0
        }
      })
    }
  }
}
</script>
<style lang="less">
/* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
}
/* 大于 750 */
@media screen and (min-width: 751px) {
  #app {
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/publication.vue